import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var getPosition = function getPosition(x, y) {
  return {
    x: Math.round(x),
    y: Math.round(y)
  };
};
export var getPositionsByDirection = function getPositionsByDirection(_ref) {
  var contentSize = _ref.contentSize,
    anchorSize = _ref.anchorSize,
    _ref$coordinates = _ref.coordinates,
    x = _ref$coordinates.x,
    y = _ref$coordinates.y,
    _ref$offsetHorizontal = _ref.offsetHorizontal,
    offsetHorizontal = _ref$offsetHorizontal === void 0 ? 0 : _ref$offsetHorizontal,
    _ref$offsetVertical = _ref.offsetVertical,
    offsetVertical = _ref$offsetVertical === void 0 ? 0 : _ref$offsetVertical;
  var contentWidth = contentSize.width,
    contentHeight = contentSize.height;
  var anchorWidth = anchorSize.width,
    anchorHeight = anchorSize.height;
  var anchorCenter = {
    x: x + anchorWidth / 2,
    y: y + anchorHeight / 2
  };
  var xForRightDirections = x + anchorWidth + offsetHorizontal;
  var xForLeftDirections = x - contentWidth - offsetHorizontal;
  var xForVerticalDirections = {
    right: anchorCenter.x,
    center: anchorCenter.x - contentWidth / 2,
    left: anchorCenter.x - contentWidth
  };
  var yForDownDirections = y + anchorHeight + offsetVertical;
  var yForUpDirections = y - contentHeight - offsetVertical;
  var yForHorizontalDirections = {
    up: anchorCenter.y - contentHeight,
    center: anchorCenter.y - contentHeight / 2,
    down: anchorCenter.y
  };
  var xForStartLeftDirections = x + offsetHorizontal;
  var xForStartRightDirections = x - contentWidth + anchorWidth - offsetHorizontal;
  var yForStartUpDirections = y + offsetVertical;
  var yForStartDownDirections = y - contentHeight + anchorHeight - offsetVertical;
  return {
    upLeft: getPosition(xForVerticalDirections.left, yForUpDirections),
    upCenter: getPosition(xForVerticalDirections.center, yForUpDirections),
    upRight: getPosition(xForVerticalDirections.right, yForUpDirections),
    downLeft: getPosition(xForVerticalDirections.left, yForDownDirections),
    downCenter: getPosition(xForVerticalDirections.center, yForDownDirections),
    downRight: getPosition(xForVerticalDirections.right, yForDownDirections),
    rightUp: getPosition(xForRightDirections, yForHorizontalDirections.up),
    rightCenter: getPosition(xForRightDirections, yForHorizontalDirections.center),
    rightDown: getPosition(xForRightDirections, yForHorizontalDirections.down),
    leftUp: getPosition(xForLeftDirections, yForHorizontalDirections.up),
    leftCenter: getPosition(xForLeftDirections, yForHorizontalDirections.center),
    leftDown: getPosition(xForLeftDirections, yForHorizontalDirections.down),
    downStartLeft: getPosition(xForStartLeftDirections, yForDownDirections),
    downStartRight: getPosition(xForStartRightDirections, yForDownDirections),
    upStartLeft: getPosition(xForStartLeftDirections, yForUpDirections),
    upStartRight: getPosition(xForStartRightDirections, yForUpDirections),
    leftStartUp: getPosition(xForLeftDirections, yForStartUpDirections),
    leftStartDown: getPosition(xForLeftDirections, yForStartDownDirections),
    rightStartUp: getPosition(xForRightDirections, yForStartUpDirections),
    rightStartDown: getPosition(xForRightDirections, yForStartDownDirections)
  };
};
export var getElement = function getElement(el) {
  return 'current' in el ? el.current : el;
};
export var getComputedPositionAndDirection = function getComputedPositionAndDirection(_ref2) {
  var initialCoords = _ref2.coordinates,
    contentSize = _ref2.contentSize,
    viewportSize = _ref2.viewportSize,
    _ref2$anchorSize = _ref2.anchorSize,
    anchorSize = _ref2$anchorSize === void 0 ? {
      width: 0,
      height: 0
    } : _ref2$anchorSize,
    _ref2$offsetHorizonta = _ref2.offsetHorizontal,
    offsetHorizontal = _ref2$offsetHorizonta === void 0 ? 0 : _ref2$offsetHorizonta,
    initialDirection = _ref2.direction,
    possibleDirections = _ref2.possibleDirections,
    bannedDirections = _ref2.bannedDirections,
    _ref2$offsetVertical = _ref2.offsetVertical,
    offsetVertical = _ref2$offsetVertical === void 0 ? 0 : _ref2$offsetVertical;
  if (!initialCoords) {
    return {
      coordinates: initialCoords,
      direction: initialDirection
    };
  }
  var positionsByDirection = getPositionsByDirection({
    contentSize: contentSize,
    anchorSize: anchorSize,
    coordinates: initialCoords,
    offsetHorizontal: offsetHorizontal,
    offsetVertical: offsetVertical
  });
  if (!contentSize.width && !contentSize.height) {
    return {
      coordinates: positionsByDirection[initialDirection],
      direction: initialDirection
    };
  }
  var direction = [initialDirection].concat(_toConsumableArray(possibleDirections)).filter(function (dir) {
    return !bannedDirections.includes(dir);
  }).find(function (dir) {
    var pos = positionsByDirection[dir];
    var width = contentSize.width,
      height = contentSize.height;
    var isFittingDown = pos.y + height <= viewportSize.height;
    var isFittingUp = pos.y >= 0;
    var isFittingLeft = pos.x >= 0;
    var isFittingRight = pos.x + width <= viewportSize.width;
    return isFittingUp && isFittingDown && isFittingLeft && isFittingRight;
  }) || initialDirection;
  return {
    direction: direction,
    coordinates: positionsByDirection[direction]
  };
};
export var getScrollPosition = function getScrollPosition(el) {
  var element = getElement(el);
  if (!element) {
    return {
      x: 0,
      y: 0
    };
  }
  if (element.tagName !== 'BODY') {
    return {
      x: element.scrollLeft,
      y: element.scrollTop
    };
  }
  if (!window) {
    return {
      x: 0,
      y: 0
    };
  }
  return {
    x: window.scrollX,
    y: window.scrollY
  };
};
export var getViewPort = function getViewPort(el) {
  var element = getElement(el);
  if (!element) {
    return {
      width: 0,
      height: 0
    };
  }
  if (element.tagName === 'BODY') {
    return {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    };
  }
  return {
    width: element.clientWidth,
    height: element.clientHeight
  };
};